PJQ.views.reporting.NewReportView = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.REPORTS, 'new-report-view'),
        subTemplates: {
            reportError: new PJQ.templating.Template(PJQ.constants.modules.REPORTS, 'report-error')
        }
    },
    events: {
        'click .create-report': 'createNewReport',
        'click .btn-save-report': 'saveReport',
        'click .btn-generate-report': 'generateReport',
        'click .btn-reset-filters': 'resetFilters',
        'click .input-my-projects': 'toggleMyProjects',
        'click .input-toggle-specific-dates': 'toggleSpecificDates',
        'click .report-export-excel': 'exportExcel',
        'click .report-export-pdf': 'exportPDF',
        'click .btn-custom-export': 'exportCustom',
        'click .btn-delete-report': 'deleteReport',
        'click .btn-clear-report': 'clearReport'
    },
    beforeFirstRender: async function () {
        if (!this.collection) {
            this.collection = new PJQ.collections.reports.NewReportList(null, {
                project: this.options.project
            });
        }

        if (!this.customReports) {
            this.customReports = new PJQ.collections.reports.CustomReports(null, {
                project: this.options.project
            });
        }

        await this.collection.fetch();
        await this.customReports.fetch();

        if (!this.options.project) {
            this.projects = new PJQ.collections.projects.Projects(null, {
                isSimple: false,
                status: 'ready'
            });

            await PJQ.app.session.fetchProjectStatuses();
            await this.projects.fetch();
        }
        this.render();
    },
    renderData: function () {
        return {
            report: this.report,
            reportType: this.reportType,
            reportList: this.collection,
            projects: this.projects
        };
    },
    getReportChoices: function () {
        let rTypes = _.filter(PJQ.constants.reports.reportTypes, (reportType) => {
                return !reportType.isCustom
                    && ((this.options.project != null && reportType.isProjectLevel !== false)
                        || (this.options.project == null && reportType.isGlobalLevel !== false));
            }),
            result = _.map(_.groupBy(rTypes, 'category', this), (reportTypes, category) => {
                return {
                    name: category,
                    choices: _.map(_.sortBy(reportTypes, 'name'), (reportType) => {
                        return {
                            id: reportType.key,
                            name: reportType.name
                        }
                    })
                };
            });

        if (_.size(this.customReports.models) > 0) {
            result.push({
                name: 'Custom Reports',
                choices: _.map(this.customReports.models, function (report) {
                    return {
                        id: 'custom_' + report.id.toString(),
                        name: report.get('name')
                    };
                })
            });
        }

        return _.sortBy(result, (rt) => {
            let s = PJQ.constants.reports.reportCategorySort[rt.name];
            return s ? s : 100;
        });
    },
    makeCustomReportType: async function (report, callback) {
        return new Promise(async (res, rej) => {
            let reportOpts = report.get('options'),
                key = report.get('key'),
                result = {
                    name: report.get('name') ?? "",
                    type: key,
                    key: key,
                    viewItemColumn: '',
                    viewRelatedItemColumn: '',
                    category: '',
                    columns: report.columns ?? [],
                    filters: report.filters ?? [],
                    isCustom: true
                };

            let filters = reportOpts.filters;
            if (_.size(filters) > 0) {
                let hasProjectCustomFieldFilter = null != _.find(filters, (filter) => {
                        return filter.projectCustomFieldId > 0;
                    }),
                    projectCustomFields = null;

                if (hasProjectCustomFieldFilter) {
                    projectCustomFields = await PJQ.app.session.fetchProjectCustomFields();
                }

                result.filters = [];
                _.each(filters, (filter) => {
                    if (filter.projectCustomFieldId > 0) {
                        let field = projectCustomFields.get(filter.projectCustomFieldId);
                        if (field != null) {
                            result.filters.push({
                                name: field.get('fieldName'),
                                key: 'pcf_' + field.id.toString(),
                                isIntChoices: true,
                                isMultiple: true,
                                inputType: 'select',
                                choices: _.map(field.choices.models, (choice) => {
                                    return {
                                        id: choice.id,
                                        name: choice.get('choiceName')
                                    };
                                })
                            });

                            result.inputType = 'select';
                            result.isMultiple = false;
                            result.isIntChoices = true;
                            result.choices = _.map(field.choices.models, (choice) => {
                                return {
                                    id: choice.id,
                                    name: choice.get('name')
                                };
                            })
                        }
                    }
                });
            }

            if (typeof callback === 'function') {
                callback(result);
            }

            res(result);
        });
    },
    afterRender: async function () {
        this.reportTypePicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-report-type'),
            defaultValue: this.reportType ? this.reportType.key : null,
            noneSelectedText: 'Select Report Type',
            choices: this.getReportChoices(),
            isMultiple: false,
            isIntChoices: false,
            onChange: (value) => {
                if (value.startsWith('custom_')) {
                    let reportId = parseInt(value.replace('custom_', '')),
                        report = this.customReports.get(reportId);
                    if (report != null) {
                        this.makeCustomReportType(report, (reportType) => {
                            this.report = report;
                            this.reportType = reportType;
                            this.render();
                        });
                    }
                    return;
                }

                this.reportType = PJQ.constants.reports.reportTypes[value];
                this.report = new PJQ.models.reports.NewReport({
                    type: this.reportType.type,
                    projectId: this.options.project ? this.options.project.id : null
                }, {
                    project: this.options.project
                });

                this.render();
            }
        });

        let selectedReportId = this.report ? this.report.get('type') != null ? this.report.id : -this.report.id : null;
        this.savedReportPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-saved-report'),
            defaultValue: selectedReportId,
            noneSelectedText: _.size(this.collection.models) > 0 || _.size(this.customReports.models) > 0 ? 'Select Saved Report' : 'No saved reports exist',
            isDisabled: _.size(this.collection.models) === 0 || _.size(this.customReports.models) > 0,
            isMultiple: false,
            isIntChoices: true,
            onChange: _.bind(function (value) {
                if (value > 0) {
                    let report = this.collection.get(value);
                    // If the report type changed, re-render to get the correct filter elements
                    if (this.reportType !== report.get('type')) {
                        this.reportType = _.find(PJQ.constants.reports.reportTypes, function (reportType) {
                            return reportType.type === report.get('type');
                        });

                        this.report = report;
                        this.render();
                    } else {
                        this.renderReport(report);
                    }
                } else {
                    this.render();
                }
            }, this)
        });

        this.populateReportSelect();
        if (this.report) {
            this.renderReport(this.report);
            this.renderDataTable();

            // If this.report is an existing report on render, then generate it immediately
            if (!this.report.isNew() && !this.report.reportData) {
                this.generateReport();
            }
        }
    },
    generateReport: function () {
        if (!this.reportType.isCustom && !this.validate()) {
            return;
        }

        if (this.reportType.isCustom) {
            let projectId = this.options.project ? this.options.project.id : null;
            this.report.generatePreview(projectId).then((response) => {
                if (response && response.content) {
                    let unescapedHtml = this.unescapeHtml(response.content);

                    let iframe = document.createElement('iframe');
                    iframe.style.width = '100%';
                    iframe.style.height = '100%';
                    iframe.style.border = 'none';

                    iframe.onload = function () {
                        iframe.contentWindow.document.open();
                        iframe.contentWindow.document.write(unescapedHtml);
                        iframe.contentWindow.document.close();
                    };

                    let container = this.$('.custom-report-preview')[0];
                    container.innerHTML = '';
                    container.appendChild(iframe);
                }
            });
        } else {
            let loader = new PJQ.Loader(this.$('.report-table'));
            this.report.setFilters(this.reportFilters);

            this.report.generate().then((response) => {
                loader.remove();
                this.renderDataTable();
            });
        }
    },
    unescapeHtml: function (html) {
        var textArea = document.createElement('textarea');
        textArea.innerHTML = html;
        return textArea.value;
    },
    exportExcel: function () {
        if (!this.validate()) {
            return;
        }

        let loader = new PJQ.Loader(this.$('.btn-export'));
        this.report.setFilters(this.reportFilters);
        this.report.export({
            format: 'excel',
            rows: this.dataTable ? this.dataTable.dataTable.rows({order: 'applied'}).data().toArray() : null
        }).then((response) => {
            PJQ.files.downloadFile(response.url, {
                isEndpoint: false
            });
            loader.remove();
        });
    },
    exportPDF: function () {
        if (!this.validate()) {
            return;
        }
        // todo: add loader to export button
        this.report.setFilters(this.reportFilters);
        this.report.export({
            format: 'pdf',
            rows: this.dataTable ? this.dataTable.dataTable.rows({order: 'applied'}).data().toArray() : null
        }).then((response) => {
            // todo: remove loader from export button
        });
    },
    exportCustom: function () {
        let loader = new PJQ.Loader(this.$('.btn-custom-export'), {
            type: 'button',
            loadingText: 'Exporting'
        });

        let projectId = this.options.project ? this.options.project.id : null;
        this.report.export(projectId).then((response) => {
            loader.remove();
        });
    },
    toggleSpecificDates: function (e) {
        let $switch = $(e.currentTarget),
            $container = $switch.closest('.col-4'),
            $dynamicDateInput = $container.find('.input-dynamic-date'),
            $specificDateInput = $container.find('.input-specific-date'),
            filters = this.report.getFilters();

        // When the user switches between dynamic/specific, we want to clear the filter of the other.
        if ($switch.prop('checked')) {
            // hide and clear the value of the select input
            $dynamicDateInput.hide().find('select').selectpicker('val', '');
            $specificDateInput.show();

            let key = $dynamicDateInput.find('select').data('key');
            // remove the key from the filters object
            delete filters[key];
            this.report.setFilters(filters);
        } else {
            // hide and clear the value of both of the date inputs
            $specificDateInput.hide().find('.filter-date').val('');
            $dynamicDateInput.show();

            let key = $specificDateInput.data('key');
            // remove the key from the filters object
            delete filters[key];
            this.report.setFilters(filters);
        }
    },
    deleteReport: function () {
        if (this.report.id == null)
            return;

        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this report?",
            onDelete: _.bind(function () {
                this.collection.remove(this.report);
                this.report.destroy({
                    success: _.bind(function () {
                        this.clearReport();
                    }, this)
                });
            }, this)
        });
    },
    clearReport: function () {
        this.report = null;
        this.reportType = null;
        this.render();
    },
    toggleMyProjects: function (e) {
        let $input = this.$('.input-my-projects'),
            filters = this.report.getFilters(),
            isChecked = $input[0].checked;

        filters.isMyProjects = isChecked;

        this.report.setFilters(filters);
        this.render();
    },
    renderReport: function (report) {
        // Stop listening to existing report
        if (this.report != null) {
            this.stopListening(this.report);
        }

        if (report != null) {
            this.report = report;
            this.reportFilters = _.clone(this.report.getFilters());
            this.$('.btn-delete-report').attr('hidden', this.report.id == null);
            this.listenTo(this.report, 'change reset', _.bind(function () {
                this.$('.btn-save-report').prop('disabled', !this.report.hasChanged());
            }, this));
        }
        this.$('.btn-save-report').prop('disabled', !this.report.hasChanged())
        this.renderFilterInputs();
    },
    getColumnChoices: async function () {
        if (!this.reportType)
            return [];

        let columns = [];
        if (typeof this.reportType.columns === 'function') {
            columns = await this.reportType.columns();
        } else {
            columns = this.reportType.columns;
        }

        let result = [],
            columnGroups = _.groupBy(columns, (col) => {
                return col.group ? col.group : '';
            }, this),
            fnMakeChoice = (column) => {
                return {
                    id: column.value,
                    name: column.display
                };
            }
        if (_.size(columnGroups) === 0) {
            result.push(..._.map(columns, fnMakeChoice));
        } else {
            _.map(columnGroups, (columns, group) => {
                result.push({
                    name: group,
                    choices: _.map(columns, fnMakeChoice)
                });
            });
        }

        if (typeof this.reportType.customFields === 'function') {
            let customFields = await this.reportType.customFields();
            if (customFields) {
                _.each(customFields.models, (field) => {
                    result.push({
                        id: "fieldValue" + field.get('fieldNumber'),
                        name: field.get('fieldName')
                    });
                });
            }
        }

        return result;
    },
    renderFilterInputs: async function () {
        if (!this.reportType.isCustom) {
            let columnChoices = await this.getColumnChoices();
            this.columnsPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.select-columns'),
                noneSelectedText: 'No Columns Selected',
                defaultValue: this.report.getColumns(),
                isMultiple: true,
                choices: columnChoices,
                isLiveSearch: true,
                onChange: _.bind(function (value) {
                    this.report.setColumns(value);
                }, this)
            });

            if (this.projects && this.reportType.filterProjects !== false) {
                this.$('.input-my-projects')[0].checked = this.reportFilters.isMyProjects;
                this.projectsSelector = new PJQ.views.projects.ProjectSelectorInput({
                    el: this.$('.report-projects'),
                    isSingleChoice: false,
                    canEdit: !this.reportFilters.isMyProjects,
                    emptyNotice: this.reportFilters.isMyProjects ? '"My Projects" is checked. This report will only use projects you are a contact on.' : 'No Project Filters',
                    selectedProjectIds: this.reportFilters.isMyProjects ? [] : this.reportFilters.projects,
                    projects: this.projects,
                    onChange: _.bind(function (selectedProjects) {
                        let idArr = _.map(selectedProjects, function (project) {
                            return project.get('projectId') ? project.get('projectId') : project.id;
                        });
                        this.reportFilters.projects = idArr;
                        this.report.setFilters(this.reportFilters);
                    }, this)
                });

                this.projectStatusPicker = new PJQ.inputs.Selectpicker({
                    el: this.$('.select-project-status-filter'),
                    defaultValue: this.reportFilters.projectStatuses,
                    noneSelectedText: 'Select Project Statuses',
                    isMultiple: true,
                    isIntChoices: true,
                    onChange: _.bind(function (value) {
                        this.reportFilters.projectStatuses = value;
                        this.report.setFilters(this.reportFilters);
                    }, this)
                });
            }
        }

        _.each(this.reportType.filters, async (filter) => {
            if (filter.inputType === PJQ.constants.reports.filterTypes.SELECT) {
                let choices;
                if (typeof filter.choices === 'function') {
                    choices = await filter.choices({project: this.options.project});
                } else {
                    choices = filter.choices;
                }

                new PJQ.inputs.Selectpicker({
                    el: this.$('.select-filter[data-key="' + (filter.key) + '"]'),
                    defaultValue: this.reportFilters[filter.key],
                    choices: choices,
                    noneSelectedText: 'Select ' + filter.name,
                    isMultiple: filter.isMultiple,
                    isIntChoices: filter.isIntChoices,
                    onChange: _.bind(function (value) {
                        this.reportFilters[filter.key] = value;
                        this.report.setFilters(this.reportFilters);
                    }, this)
                });
            } else if (filter.inputType === PJQ.constants.reports.filterTypes.DATE_RANGE) {
                let $range = this.$('.input-specific-date[data-key="' + (filter.key) + '"]'),
                    dateRange = [null, null],
                    defaultDateOne = this.reportFilters[filter.key] ? PJQ.helpers.dateHelpers.parseDateString(dateRange[0], false) : null,
                    defaultDateTwo = this.reportFilters[filter.key] ? PJQ.helpers.dateHelpers.parseDateString(dateRange[1], false) : null,
                    fnSetFilter = () => {
                        let date1 = dateRange[0] ? dateRange[0] : "null",
                            date2 = dateRange[1] ? dateRange[1] : "";
                        this.reportFilters[filter.key] = date1 + '|' + date2;
                        this.report.setFilters(this.reportFilters);
                    },
                    datePickerFrom = new PJQ.inputs.Datepicker({
                        el: $range.find('.date-from'),
                        datepickerOptions: {
                            format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                            defaultDate: null
                        },
                        onChange: _.bind(function (date) {
                            dateRange[0] = date ? PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE) : null;
                            fnSetFilter();
                        }, this)
                    }),
                    datePickerTo = new PJQ.inputs.Datepicker({
                        el: $range.find('.date-to'),
                        datepickerOptions: {
                            format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                            defaultDate: null
                        },
                        onChange: _.bind(function (date) {
                            dateRange[1] = date ? PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE) : null;
                            fnSetFilter();
                        }, this)
                    });

                let filterVal = this.reportFilters[filter.dynamicKey],
                    dynVal = null;
                if (typeof filterVal === 'string') {
                    dynVal = filterVal.replace('dyn:', '');
                }
                new PJQ.inputs.Selectpicker({
                    el: this.$('.select-dynamic-date[data-key="' + (filter.dynamicKey) + '"]'),
                    defaultValue: dynVal,
                    noneSelectedText: 'Select ' + filter.name + ' Range',
                    isMultiple: false,
                    isIntChoices: false,
                    onChange: _.bind(function (value) {
                        this.reportFilters[filter.dynamicKey] = _.size(value) > 0 ? ("dyn:" + value) : null;
                        this.report.setFilters(this.reportFilters);
                    }, this)
                });

                datePickerFrom.setValueSilently(defaultDateOne);
                datePickerTo.setValueSilently(defaultDateTwo);
            }
        }, this)
    },
    renderDataTable: function () {
        let filteredMoneyColumns;
        // Currently we only want to render a footer for money columns
        if (this.report && this.report.reportData) {
            filteredMoneyColumns = _.filter(this.report.reportData.columns, function (column) {
                return column.type === 'money';
            }, this)
        }

        let order = [],
            opts = this.report.get('options'),
            cOrder = opts ? this.report.get('options').columnOrder : null;
        if (this.report.reportData && this.report.reportData.columns && _.size(cOrder) >= 2 &&
            this.report.get('options').columnOrder[0] < _.size(this.report.reportData.columns)) {
            order = [cOrder];
        }

        this.dataTable = new PJQ.views.reporting.ReportCenterDataTable({
            el: this.$('.report-table'),
            paging: false,
            hasFooter: _.size(filteredMoneyColumns) > 0,
            data: this.report.reportData ? this.report.reportData.rows : null,
            columnData: this.report.reportData ? this.report.reportData.columns : null,
            order: order,
            reportType: this.reportType,
            orderByChanged: _.bind(function (details) {
                let options = this.report.get('options');
                options.columnOrder = [details[0].col, details[0].dir];
                this.report.set('options', options);
            }, this),
            columnOrderChanged: _.bind(function (columns) {
                this.report.setColumns(_.map(columns, function (column) {
                    return column.data;
                }));
            }, this),
            afterDataTableRender: _.bind(function () {
                if (_.size(filteredMoneyColumns) > 0) {
                    this.renderTableFooter();
                }
            }, this),
            viewItem: _.bind(function (id) {
                if (id) {
                    this.viewReportItem(id);
                }
            }, this),
            viewRelatedItem: _.bind(function (id) {
                if (id) {
                    this.viewRelatedReportItem(id);
                }
            }, this)
        });
    },
    renderTableFooter: function () {
        let $footer = this.$('tfoot').first();
        _.each(this.report.reportData.columns, function (column, index) {
            if (column.type != null && column.type.toLowerCase() === 'money') {
                let total = 0;
                _.each(this.report.reportData.rows, function (row) {
                    if (row[column.index] != null) {
                        total += parseInt(PJQ.helpers.formatHelpers.numbersOnly(row[column.index], false, true));
                    }
                });

                let $footerCol = $footer.find('th').eq(index);
                $footerCol.text(PJQ.helpers.formatHelpers.formatCurrency(total));
            }
        }, this);
    },
    viewReportItem: function (id) {
        switch (this.reportType.type) {
            case PJQ.constants.reports.PAYABLE_INVOICE.type:
                new PJQ.views.invoicing.EditPayableInvoiceModal({
                    model: new PJQ.models.invoicing.PayableInvoice({
                        id: id
                    })
                })
                break;
            case PJQ.constants.reports.RECEIVABLE_INVOICE.type:
                new PJQ.views.invoicing.EditReceivableInvoiceModal({
                    model: new PJQ.models.invoicing.ReceivableInvoice({
                        id: id
                    })
                })
                break;
            case PJQ.constants.reports.DIRECT_COST.type:
                new PJQ.views.directcosts.DirectCostEditModal({
                    model: new PJQ.models.directcosts.DirectCost({
                        id: id
                    })
                })
                break;
            case PJQ.constants.reports.COMMITMENT.type:
                new PJQ.views.commitments.CommitmentEditModal({
                    model: new PJQ.models.commitments.Commitment({
                        id: id
                    })
                })
                break;
            case PJQ.constants.reports.CONTRACT.type:
                new PJQ.views.primeContracts.PrimeContractEditModal({
                    model: new PJQ.models.primeContracts.PrimeContract({
                        id: id
                    })
                })
                break;
            case PJQ.constants.reports.CONTRACT_CHANGE_ORDER.type:
                new PJQ.views.primeContracts.ChangeOrderEditModal({
                    model: new PJQ.models.primeContracts.ChangeOrder({
                        id: id
                    })
                })
                break;
            case PJQ.constants.reports.COMMITMENT_CHANGE_ORDER.type:
                new PJQ.views.commitments.ChangeOrderEditModal({
                    model: new PJQ.models.commitments.ChangeOrder({
                        id: id
                    })
                })
                break;
        }
    },
    viewRelatedReportItem: function (id) {
        switch (this.reportType.type) {
            case PJQ.constants.reports.PAYABLE_INVOICE.type:
                new PJQ.views.commitments.CommitmentEditModal({
                    model: new PJQ.models.commitments.Commitment({
                        id: id
                    })
                })
                break;
            case PJQ.constants.reports.RECEIVABLE_INVOICE.type:
                new PJQ.views.primeContracts.PrimeContractEditModal({
                    model: new PJQ.models.primeContracts.PrimeContract({
                        id: id
                    })
                })
                break;
            case PJQ.constants.reports.CONTRACT_CHANGE_ORDER.type:
                new PJQ.views.primeContracts.PrimeContractEditModal({
                    model: new PJQ.models.primeContracts.PrimeContract({
                        id: id
                    })
                })
                break;
            case PJQ.constants.reports.COMMITMENT_CHANGE_ORDER.type:
                new PJQ.views.commitments.CommitmentEditModal({
                    model: new PJQ.models.commitments.Commitment({
                        id: id
                    })
                })
                break;
        }
    },
    validate: function () {
        let isValid = true;
        if (_.size(this.report.getColumns()) === 0) {
            isValid = false;
        }

        if (this.columnsPicker != null) {
            isValid ? this.columnsPicker.hideError() : this.columnsPicker.showError();
        }
        return isValid;
    },
    saveReport: function () {
        if (!this.validate()) {
            return;
        }

        let isNew = this.report.isNew();
        new PJQ.views.reporting.EditReportModal({
            project: this.options.project,
            model: this.report,
            onSave: _.bind(function () {
                this.report.save(null, {
                    success: _.bind(function (model) {
                        if (isNew) {
                            this.collection.add(model);
                        }
                        this.populateReportSelect();

                        PJQ.notifications.notify.successNotify({
                            message: 'Report successfully saved'
                        });
                    }, this)
                })
            }, this)
        });
    },
    populateReportSelect: function () {
        // Group the reports by their type
        let groupedReports = _.groupBy(this.collection.models, function (report) {
            return report.get('type');
        });

        // Convert groupedReports to the format that updateChoices expects
        let choices = _.map(groupedReports, function (reports, type) {
            return {
                name: _.find(PJQ.constants.reports.reportTypes, function (reportType) {
                    return reportType.type === type;
                }).name,
                choices: _.map(reports, function (report) {
                    return {
                        id: report.id,
                        name: report.get('name'),
                        isCustom: false
                    };
                })
            };
        });

        if (this.savedReportPicker) {
            this.savedReportPicker.updateChoices(choices);
            let selectedReportId = this.report ? this.report.get('type') != null ? this.report.id : -this.report.id : null;
            this.savedReportPicker.setValue(selectedReportId);
            if (_.size(this.collection.models) > 0 || _.size(this.customReports.models) > 0) {
                this.savedReportPicker.enable();
            } else {
                this.savedReportPicker.disable();
            }
        }

        if (this.report) {
            this.$('.btn-delete-report').attr('hidden', this.report.id == null);
        }
    },
    resetFilters: function () {
        this.report.resetFilters();
        this.renderReport(null);
    }
});

PJQ.views.reporting.EditReportModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.REPORTS, 'modal-edit-report'),
        width: '50%',
        maxWidth: 400,
        model: null,
        isShowCloseButton: true,
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-save': 'save'
    },
    beforeRender: function () {

    },
    renderData: function () {
        return {
            model: this.model
        }
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: ['input']
        });

        this.setInputFocus(this.$('.input-report-name')[0]);
    },
    setInputFocus: function (input) {
        input.focus();
        input.setSelectionRange(input.value.length, input.value.length);
    },
    save: function () {
        this.options.onSave(this.model);
        this.removeModal();
    },
    close: function () {
        this.removeModal();
    }
});

PJQ.views.reporting.ReportCenterDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'Select from your saved reports, or create a new one to get started',
            zeroRecords: "No records match your request"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.REPORTS, 'data-table-header-report-center')
        },
        colReorder: {
            realtime: false
        }
    },
    events: {
        'click .view-item': 'viewItem',
        'click .view-related-item': 'viewRelatedItem'
    },
    afterHeaderRender: function () {

    },
    getColumns: function () {
        let columns = []

        if (this.options.columnData) {
            _.each(this.options.columnData, function (column) {
                columns.push({
                    "data": column.dataValue,
                    "title": column.displayValue,
                    "render": _.bind(function (dt, type, row) {
                        let data = row.data[column.index],
                            displayValue = data && data.text ? data.text : data;
                        if (column.type.toLowerCase() === 'money') {
                            displayValue = PJQ.helpers.formatHelpers.formatCurrency(displayValue);
                        }

                        if (column.type.indexOf('viewItem:') !== -1) {
                            let itemType = column.type.replace('viewItem:', '');
                            return '<a class="view-item" href="javascript:void(0)" data-item-type="' + itemType + '" data-id="' + row.props.id + '">' + displayValue + '</a>';
                        } else if (column.type === 'url') {
                            return '<a class="view-item" target="_blank" href="#' + data.url + '">' + displayValue + '</a>';
                        }
                        return displayValue;
                    }, this)
                });
            }, this)
        } else {
            columns.push({
                "data": '',
                "title": '',
            })
        }

        return columns;
    },
    viewItem: function (e) {
        e.stopImmediatePropagation();
        let id = $(e.currentTarget).data('id');
        if (typeof this.options.viewItem === 'function') {
            this.options.viewItem(id);
        }
    },
    viewRelatedItem: function (e) {
        e.stopImmediatePropagation();
        let id = $(e.currentTarget).data('id');
        if (typeof this.options.viewItem === 'function') {
            this.options.viewRelatedItem(id);
        }
    }
});